<template>
    <div class="profile">
        <div class="title">公司介绍</div>
        <div class="tips">专业的制冷设备与水族解决方案提供商</div>

        <div class="profile-content">
            <div class="profile-desc">
                广东豪嘉制冷设备有限公司是一家集先进技术、顶尖人才、优势资源于一体 的专业从事IoT物联网制冷设备的研发，生产，销售以及售后服务的综合 公司。<br /><br />
                公司由多名资深的制冷工程师、经验丰富的研发团队、专业的 互联网IT团队，以及精英的销售团队组成，应用IOT技术，将我们生产的每一台设备连接互联网，极大程度上便捷了用户操作，更便捷了对设备的管理，实现了远程控制制冷设备以及同时控制多台设备的重大突破，走在了行业的最前端。<br /><br />
                互相联为公司旗下的第一个品牌。<br />
            </div>
            <img src="../assets/image/bg_1.webp" class="vue-lazy">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProfileComp'
}
</script>

<style scoped lang="scss">
.profile {
    padding: 80px;
    box-sizing: border-box;
    width: 100%;

    .title {
        color: #000000;
        font-family: "Inter";
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        text-align: center;
        margin-bottom: 18px;
    }

    .tips {
        color: #4B5563;
        font-family: "Inter";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin-bottom: 50px;
    }

    .profile-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 48px;

        .profile-desc {
            flex: 1 1 50%;
            color: #4B5563;
            font-family: "Inter";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
        }

        img {
            border-radius: 10px;
            box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.3);
            flex: 1 1 50%;
            max-width: 45%;
            height: auto;
        }
    }
}

@media (max-width: 768px) {
    .profile {
        padding: 40px 20px;

        .title {
            font-size: 24px;
            margin-bottom: 12px;
        }

        .tips {
            font-size: 14px;
            margin-bottom: 32px;
        }

        .profile-content {
            flex-direction: column;

            .profile-desc {
                font-size: 14px;
                line-height: 1.8;
                margin-bottom: 24px;
            }

            img {
                width: 100%;
                max-width: 100%;
                height: auto;
                order: -1;
            }
        }
    }
}
</style>